import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_adminGuarded/admin/leagues")({
  component: AdminLeaguesLayout,
});

function AdminLeaguesLayout() {
  return <Outlet />;
}
